/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { NavLink } from 'react-router-dom'
import colors from '@sportninja/common/constants/appColors'
import { paragraphSmall, weightRegular } from 'src/components/css'
import { ProfilePageConfig } from '../types'
import { CONTENT_GUTTER, MAX_CONTENT_WIDTH } from '../utils/constants'

interface ProfileNavBarProps {
  pages: ProfilePageConfig[]
}

const ProfileNavBar: React.FC<ProfileNavBarProps> = ({ pages }) => {
  return (
    <div
      css={css`
        background-color: ${colors.SECONDARY_400};
        border-bottom: 1px solid ${colors.SECONDARY_200};
        width: 100%;
      `}
    >
      <div
        css={css`
          max-width: ${MAX_CONTENT_WIDTH}px;
          margin: 0 auto;
          padding-left: ${CONTENT_GUTTER}px;
          padding-right: ${CONTENT_GUTTER}px;
          display: flex;
          align-items: center;
        `}
      >
        {pages.map((page) => {
          return (
            <NavLink
              key={page.to}
              to={page.to}
              exact
              css={css`
                ${paragraphSmall}
                ${weightRegular}
                min-height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 8px;
                text-decoration: none;
                white-space: nowrap;
                border-bottom: 2px solid transparent;
                color: ${colors.NEUTRAL_50};
                transition: color 0.15s ease, border-color 0.15s ease;
                &:hover {
                  color: ${colors.NEUTRAL_0};
                }

                &.active {
                  color: ${colors.NEUTRAL_0};
                  font-weight: 700;
                  border-bottom-color: ${colors.PRIMARY};
                }
              `}
              activeClassName='active'
            >
              {page.text}
            </NavLink>
          )
        })}
      </div>
    </div>
  )
}

export default ProfileNavBar
